function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "1.0.3-POLA-UPRAWNE----Nawozy----Zarza\u0328dzanie-Dodatkowymi--",
  transform: "translate(-1453.000000, -353.000000)"
}, React.createElement("g", {
  id: "kalkulatort",
  transform: "translate(0.000000, 307.000000)"
}, React.createElement("g", {
  id: "separator",
  transform: "translate(374.000000, 42.000000)"
}, React.createElement("g", {
  id: "txt",
  transform: "translate(1067.000000, 0.000000)"
}, React.createElement("g", {
  id: "ico/smietnik",
  transform: "translate(12.000000, 4.000000)"
}, React.createElement("g", {
  id: "Outline",
  transform: "translate(3.000000, 2.000000)"
}, React.createElement("path", {
  fill: "currentColor",
  d: "M13.3333333,4.21052632 L13.3333333,14.3157895 C13.3333333,15.2446316 12.5858333,16 11.6666667,16 L11.6666667,16 L3.33333333,16 C2.41416667,16 1.66666667,15.2446316 1.66666667,14.3157895 L1.66666667,14.3157895 L1.66666667,4.21052632 L13.3333333,4.21052632 Z M11.6666667,5.89473684 L3.33333333,5.89473684 L3.33333333,14.3157895 L11.6675,14.3157895 L11.6666667,5.89473684 Z M6.66666667,7.57894737 L6.66666667,12.6315789 L5,12.6315789 L5,7.57894737 L6.66666667,7.57894737 Z M10,7.57894737 L10,12.6315789 L8.33333333,12.6315789 L8.33333333,7.57894737 L10,7.57894737 Z M10,0 L10,1.68421053 L15,1.68421053 L15,3.36842105 L0,3.36842105 L0,1.68421053 L5,1.68421053 L5,0 L10,0 Z",
  id: "Combined-Shape"
})))))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    version: 1.1
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/smietnik.60003aa6.svg";
export { SvgComponent as ReactComponent };